<!-- 收藏组件 组件 -->

<template>
  <div class="CollectElement" @click="collect()">
    <img class="mui-media-object mui-pull-left" v-if="!collectState" src="../assets/uncollection.png" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
    <img class="mui-media-object mui-pull-left" v-if="collectState" src="../assets/collection.png" style="height:18px;width:18px;vertical-align:text-top;margin-right:4px;">
    <span style="font-size: .6rem;">收藏</span>
  </div>
</template>

<script>
import axios from "axios";
import Addr from "./../utils/getAPI";
import store from "../store";
import Qs from "qs";
import { Toast } from "mint-ui";
export default {
  name: "CollectElement",
  // collectIndex,collectData,collectArr
  components: {},
  data() {
    return {
      // uncollection: uncollection,
      // collection: collection
    };
  },
  props: {
    collectState: Boolean,
    collectData: Object,
    collectId: Number,
    collectType: String
  },
  watch: {},
  methods: {
    collect() {
      if (this.$store.state.mineStore.isLogin == false) {
        Toast({
          message: "请先登录",
          position: "bottom",
          duration: 800
        });
        return;
      }

      console.log("isLogin is:");
      console.log(this.$store.state.mineStore.isLogin);
      this.collectState = !this.collectState;
      this.collectData.collectionType = this.collectState;
      //this.sizhengs.$set(index,sizheng);
      //this.$set(this.collectArr,this.collectIndex,this.collectData);
      //this.$set(this.collectData, "collectionType", this.collectData.collectionType);
      console.log("collection state is:");
      console.log(this.collectData.collectionType);

      //redis中的key  例如id.sizhengCollect
      var redisKey =
        this.$store.state.mineStore.userId + "." + this.collectType;
      var redisValue = this.collectId;

      axios
        .post(
          Addr.getGoNewAPIPrefix() + "user/collect",
          Qs.stringify({
            key: redisKey,
            value: redisValue,
            operation: this.collectData.collectionType ? 1 : 0
          })
        )
        .then(res => {
          if (res.data.returnCode == 100) {
            console.log("collect success");
            console.log("userId is:");
            console.log(res.data.returnData);
          }
        })
        .catch(err => {
          Toast({
            message: "收藏功能异常！",
            position: "bottom",
            duration: 800
          });
          console.log("collect failed");
          console.log(err);
        });
    }
  },
  filters: {},
  computed: {},
  created() {},
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/collect.vue